const responseTemplates = {
  getApplicationTemplateResponseCategories: async function(
    type,
    showArchived = false
  ) {
    var query =
      `{
        applicationTemplateResponseCategories(type: ` +
      parseInt(type) +
      `, showArchived: ` +
      showArchived +
      `) {
          Application_Template_Response_Category_Id
          Category
          Summary
          Is_Archived
          Application_Template_Responses{
            Application_Template_Response_Id
            Question
            Response
            Is_Archived
          }
        }
      }`;
    return await this.$store.getters.fetcher({ query }).then(r => {
      return r.data.applicationTemplateResponseCategories;
    });
  },
  getApplicationTemplateResponseCategoriesWithAnswers: async function(type) {
    var query =
      `{
        applicationTemplateResponseCategories(type: ` +
      parseInt(type) +
      `) {
          Application_Template_Resopnse_Category_Id
          Category
          Summary
          Application_Template_Responses{
            Application_Template_Response_Id
            Question
            Response
            Template_Response_Blank_Answers(userId: ` +
      this.$store.getters.user.User_Id +
      `){
              Template_Response_Blank_Answer_Id
              Application_Template_Response_Id
              Blank_Number
              Answer
            }
          }
        }
      }`;
    return await this.$store.getters.fetcher({ query }).then(r => {
      return r.data.applicationTemplateResponseCategories;
    });
  },

  createApplicationTemplateResponseCategory: async function(
    responseCategoryToCreate
  ) {
    var query = `
      mutation($category: String!, $summary: String!, $applicationTemplateResponseType: Int!){
        CreateApplicationTemplateResponseCategory(category: $category, summary: $summary, applicationTemplateResponseType: $applicationTemplateResponseType){
          Application_Template_Response_Category_Id
        }
      }`;
    var variables = {
      category: responseCategoryToCreate.Category,
      summary: responseCategoryToCreate.Summary,
      applicationTemplateResponseType:
        responseCategoryToCreate.Application_Template_Response_Type
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      responseCategoryToCreate.Application_Template_Response_Category_Id =
        r.data.CreateApplicationTemplateResponseCategory.Application_Template_Response_Category_Id;
      return responseCategoryToCreate;
    });
  },

  updateApplicationTemplateResponseCategory: async function(
    responseCategoryToUpdate
  ) {
    var query = `
      mutation($applicationTemplateResponseCategoryId: Int!, $category: String!, $summary: String!, $applicationTemplateResponseType: Int!){
        UpdateApplicationTemplateResponseCategory(applicationTemplateResponseCategoryId: $applicationTemplateResponseCategoryId, category: $category, summary: $summary, applicationTemplateResponseType: $applicationTemplateResponseType){
          Application_Template_Response_Category_Id
        }
      }`;
    var variables = {
      applicationTemplateResponseCategoryId: parseInt(
        responseCategoryToUpdate.Application_Template_Response_Category_Id
      ),
      category: responseCategoryToUpdate.Category,
      summary: responseCategoryToUpdate.Summary,
      applicationTemplateResponseType: parseInt(
        responseCategoryToUpdate.Application_Template_Response_Type
      )
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      responseCategoryToUpdate.Application_Template_Response_Category_Id =
        r.data.UpdateApplicationTemplateResponseCategory.Application_Template_Response_Category_Id;
      return responseCategoryToUpdate;
    });
  },

  archiveApplicationTemplateResponseCategory: async function(
    applicationTemplateResponseCategoryId
  ) {
    var query = `
      mutation($applicationTemplateResponseCategoryId: Int!){
        ArchiveApplicationTemplateResponseCategory(applicationTemplateResponseCategoryId: $applicationTemplateResponseCategoryId)
      }`;
    var variables = {
      applicationTemplateResponseCategoryId: parseInt(
        applicationTemplateResponseCategoryId
      )
    };
    return await this.$store.getters
      .fetcher({ query, variables })
      .then(r => r.data.ArchiveApplicationTemplateResponseCategory);
  },

  createApplicationTemplateResponse: async function(responseToCreate) {
    var query = `
      mutation($question: String!, $response: String!, $applicationTemplateResponseCategoryId: Int!){
        CreateApplicationTemplateResponse(question: $question, response: $response, applicationTemplateResponseCategoryId: $applicationTemplateResponseCategoryId){
          Application_Template_Response_Id
        }
      }`;
    var variables = {
      question: responseToCreate.Question,
      response: responseToCreate.Response,
      applicationTemplateResponseCategoryId: parseInt(
        responseToCreate.Application_Template_Response_Category_Id
      )
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      responseToCreate.Application_Template_Response_Id =
        r.data.CreateApplicationTemplateResponse.Application_Template_Response_Id;
      return responseToCreate;
    });
  },

  updateApplicationTemplateResponse: async function(responseToUpdate) {
    var query = `
      mutation($applicationTemplateResponseId: Int!, $question: String!, $response: String!, $applicationTemplateResponseCategoryId: Int!){
        UpdateApplicationTemplateResponse(applicationTemplateResponseId: $applicationTemplateResponseId, question: $question, response: $response, applicationTemplateResponseCategoryId: $applicationTemplateResponseCategoryId){
          Application_Template_Response_Id
        }
      }`;
    var variables = {
      applicationTemplateResponseId: parseInt(
        responseToUpdate.Application_Template_Response_Id
      ),
      question: responseToUpdate.Question,
      response: responseToUpdate.Response,
      applicationTemplateResponseCategoryId: parseInt(
        responseToUpdate.Application_Template_Response_Category_Id
      )
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      responseToUpdate.Application_Template_Reponse_Id =
        r.data.UpdateApplicationTemplateResponse.Application_Template_Response_Id;
      return responseToUpdate;
    });
  },

  archiveApplicationTemplateResponse: async function(
    applicationTemplateResponseId
  ) {
    var query = `
      mutation($applicationTemplateResponseId: Int!){
        ArchiveApplicationTemplateResponse(applicationTemplateResponseId: $applicationTemplateResponseId)
      }`;
    var variables = {
      applicationTemplateResponseId: parseInt(applicationTemplateResponseId)
    };
    return await this.$store.getters
      .fetcher({ query, variables })
      .then(r => r.data);
  },

  createTemplateResponseBlankAnswer: async function(answerToCreate) {
    var query = `
      mutation($applicationTemplateResponseId: Int!, $userId: Int!, $blankNumber: Int!, $answer: String!){
        CreateTemplateResponseBlankAnswer(applicationTemplateResponseId: $applicationTemplateResponseId, userId: $userId, blankNumber: $blankNumber, answer: $answer){
          Template_Response_Blank_Answer_Id
        }
      }`;
    var variables = {
      applicationTemplateResponseId: parseInt(
        answerToCreate.Application_Template_Response_Id
      ),
      blankNumber: parseInt(answerToCreate.Blank_Number),
      answer: answerToCreate.Answer,
      userId: parseInt(this.$store.getters.user.User_Id)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      answerToCreate.Template_Response_Blank_Answer_Id =
        r.data.CreateTemplateResponseBlankAnswer.Template_Response_Blank_Answer_Id;
      return answerToCreate;
    });
  },

  updateTemplateResponseBlankAnswer: async function(answerToUpdate) {
    var query = `
      mutation($templateResponseBlankAnswerId: Int!, $answer: String!){
        UpdateTemplateResponseBlankAnswer(templateResponseBlankAnswerId: $templateResponseBlankAnswerId, answer: $answer){
          Template_Response_Blank_Answer_Id
        }
      }`;
    var variables = {
      templateResponseBlankAnswerId: parseInt(
        answerToUpdate.Template_Response_Blank_Answer_Id
      ),
      answer: answerToUpdate.Answer
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      answerToUpdate.Template_Response_Blank_Answer_Id =
        r.data.UpdateTemplateResponseBlankAnswer.Template_Response_Blank_Answer_Id;
      return answerToUpdate;
    });
  },

  removeTemplateResponseBlankAnswer: async function(
    templateResponseBlankAnswerId
  ) {
    var query = `
      mutation($templateResponseBlankAnswerId: Int!){
        RemoveTemplateResponseBlankAnswer(templateResponseBlankAnswerId: $templateResponseBlankAnswerId){
          Template_Response_Blank_Answer_Id
        }
      }  
    `;
    var variables = {
      templateResponseBlankAnswerId: parseInt(templateResponseBlankAnswerId)
    };
    return await this.$store.getters
      .fetcher({ query, variables })
      .then(r => r.data.RemoveTemplateResponseBlankAnswer);
  },

  cleanResponse: function(response) {
    var returnResponse = response.replace(
      /[@]blank-\d+[@]hint:/g,
      "<span class='text-secondary font-italic'>__________"
    );
    returnResponse = returnResponse.replace(
      /[@]blank-\d+[@]/g,
      "<span class='text-secondary font-italic'>__________</span>"
    );
    returnResponse = returnResponse.replace(/[@]/g, "</span>");
    return returnResponse;
  }
};

export { responseTemplates };
